/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Company } from '../../models/company';

export interface GetFavoriteCompanies$Params {
  accountId: string;
}

export function getFavoriteCompanies(http: HttpClient, rootUrl: string, params: GetFavoriteCompanies$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Company>>> {
  const rb = new RequestBuilder(rootUrl, getFavoriteCompanies.PATH, 'get');
  if (params) {
    rb.path('accountId', params.accountId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<Company>>;
    })
  );
}

getFavoriteCompanies.PATH = '/account/{accountId}/favorites/companies';
